import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { PieChart } from "@mui/x-charts/PieChart";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  dashboard,
  energy,
  dashboardUserGraph,
  dashboardDeviceGraph,
  paiChartDevice,
  projectList,
  userAndDevices,
  averageDeviceUsage,
} from "../redux/actions/userAuth";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
const { combine, allowedMaxDays, afterToday } = DateRangePicker;
const Dashboard = () => {
  const status = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [energydata, setEnergyData] = useState([]);
  const [paichart, setPaichart] = useState([]);
  const [averageDevice, setAverageDevice] = useState([]);
  const [dashboarddata, setDashboardData] = useState({
    data: {
      totalUsers: "wait...",
      totaldevice: "wait...",
      totalassigneddevice: "wait...",
      totalunassigneddevice: "wait...",
    },
  });
  const [series, setSeries] = useState([]);
  const [userDevice2, setUserDevice2] = useState();
  const [userDevice, setUserDevice] = useState();
  const [Deviceseries, setDeviceSeries] = useState([]);
  const [xAxisData, setXAxisData] = useState([]);
  const [DevicexAxisData, setDeviceXAxisData] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedDates1, setSelectedDates1] = useState([]);
  const [projectLst, setProjectLst] = useState();
  const [data, setData] = useState({
    userId: "",
    deviceId: "",
    startDate: "",
    endDate: "",
    address: "",
    project: "",
    stateName: "",
    AstartDate: "",
    AendDate: "",
    block: "", //changes
    district: "", //changes
  });
  // Dashboard device by month

  useEffect(() => {
    dispatch(dashboardDeviceGraph());
  }, []);
  useEffect(() => {
    dispatch(dashboard());
  }, []);
  // Dashboard device by month
  // user by month

  useEffect(() => {
    const apiData = {};
    dispatch(dashboardUserGraph(apiData));
  }, []);
  useEffect(() => {
    dispatch(projectList());
  }, []);
  useEffect(() => {
    if (status.projectList?.successData?.data !== "") {
      if (status.projectList?.successData?.status === 200) {
        setProjectLst(status?.projectList?.successData?.data);
      }
    }
  }, [status]);

  // pai chart device
  useEffect(() => {
    dispatch(paiChartDevice());
    dispatch(averageDeviceUsage());
  }, []);

  useEffect(() => {
    const apiData = {};
    dispatch(energy(apiData));
  }, []);

  useEffect(() => {
    dispatch(userAndDevices());
  }, []);
  useEffect(() => {
    if (
      status.userAndDevices?.successData?.data !== "" &&
      status.userAndDevices?.successData?.data !== null
    ) {
      if (status.userAndDevices?.successData?.status === 200) {
        const uniqueIdsMap2 = status.userAndDevices?.successData?.data.reduce(
          (map, obj) => {
            map.set(obj?.district);
            return map;
          },
          new Map()
        );
        const uniqueObjects2 = Array.from(uniqueIdsMap2, ([district]) => ({
          district,
        }));
        setUserDevice2(uniqueObjects2);

        const uniqueIdsMap = status.userAndDevices?.successData?.data.reduce(
          (map, obj) => {
            if (obj?.device_id && obj?.name) {
              map.set(obj.device_id, obj.name);
            }
            return map;
          },
          new Map()
        );
        const uniqueObjects = Array.from(uniqueIdsMap, ([device_id, name]) => ({
          device_id,
          name,
        }));
        setUserDevice(uniqueObjects);
      }
    }
  }, [status]);
  const filterProject = (e) => {
    setData({
      ...data,
      project: e.target.value,
    });
    dispatch(
      dashboardDeviceGraph(
        e.target.value,
        data.stateName,
        data.block,
        data.district
      )
    ); //changes
    dispatch(
      dashboardUserGraph(
        e.target.value,
        data.stateName,
        data.block,
        data.district
      )
    ); //changes
    dispatch(
      energy("", "", "", "", "", e.target.value, data.stateName, "", "", "")
    ); //changes
    dispatch(
      dashboard(e.target.value, data.stateName, data.block, data.district)
    ); //changes
    dispatch(
      paiChartDevice(
        data.startDate,
        data.endDate,
        e.target.value,
        data.stateName,
        data.block, //changes
        data.district //changes
      )
    );
    dispatch(
      averageDeviceUsage(
        data.AstartDate,
        data.AendDate,
        e.target.value,
        data.stateName,
        data.block, //changes
        data.district, //changes
        data.deviceId
      )
    );
  };
  const stateChange = (e) => {
    setData({
      ...data,
      stateName: e.target.value,
    });
    dispatch(
      dashboardDeviceGraph(
        data.project,
        e.target.value,
        data.block,
        data.district
      )
    );
    dispatch(
      dashboardUserGraph(
        data.project,
        e.target.value,
        data.block,
        data.district
      )
    );
    dispatch(
      energy(
        "",
        "",
        "",
        "",
        "",
        data.project,
        e.target.value,
        data.block,
        data.district
      )
    );
    dispatch(
      dashboard(data.project, e.target.value, data.block, data.district)
    );
    dispatch(
      paiChartDevice(
        data.startDate,
        data.endDate,
        data.project,
        e.target.value,
        data.block,
        data.district
      )
    );
    dispatch(
      averageDeviceUsage(
        data.AstartDate,
        data.AendDate,
        data.project,
        e.target.value,
        data.block,
        data.district,
        data.deviceId
      )
    );
  };

  //changes
  const blockChange = (e) => {
    setData({
      ...data,
      block: e.target.value,
    });
    dispatch(
      dashboardDeviceGraph(
        data.project,
        data.stateName,
        e.target.value,
        data.district
      )
    );
    dispatch(
      dashboardUserGraph(
        data.project,
        data.stateName,
        e.target.value,
        data.district
      )
    );
    dispatch(
      energy(
        "",
        "",
        "",
        "",
        "",
        data.project,
        data.stateName,
        e.target.value,
        data.district
      )
    );
    dispatch(
      dashboard(data.project, data.stateName, e.target.value, data.district)
    );
    dispatch(
      paiChartDevice(
        data.startDate,
        data.endDate,
        data.project,
        data.stateName,
        e.target.value,
        data.district
      )
    );
    dispatch(
      averageDeviceUsage(
        data.AstartDate,
        data.AendDate,
        data.project,
        data.stateName,
        e.target.value,
        data.district,
        data.deviceId
      )
    );
  };

  //changes
  const districtChange = (e) => {
    setData({
      ...data,
      district: e.target.value,
    });
    dispatch(
      dashboardDeviceGraph(
        data.project,
        data.stateName,
        data.block,
        e.target.value
      )
    );
    dispatch(
      dashboardUserGraph(
        data.project,
        data.stateName,
        data.block,
        e.target.value
      )
    );
    dispatch(
      energy(
        "",
        "",
        "",
        "",
        "",
        data.project,
        data.stateName,
        data.block,
        e.target.value
      )
    );
    dispatch(
      dashboard(data.project, data.stateName, data.block, e.target.value)
    );
    dispatch(
      paiChartDevice(
        data.startDate,
        data.endDate,
        data.project,
        data.stateName,
        data.block,
        e.target.value
      )
    );
    dispatch(
      averageDeviceUsage(
        data.AstartDate,
        data.AendDate,
        data.project,
        data.stateName,
        data.block,
        e.target.value,
        data.deviceId
      )
    );
  };

  const userChange = (e) => {
    setData({
      ...data,
      deviceId: e.target.value,
    });
    dispatch(
      averageDeviceUsage(
        data.AstartDate,
        data.AendDate,
        data.project,
        data.stateName,
        e.target.value
      )
    );
  };

  //changes

  const districtChangeFilter = (e) => {
    setData({
      ...data,
      district: e.target.value, //changes
    });
    dispatch(
      averageDeviceUsage(
        data.AstartDate,
        data.AendDate,
        data.project,
        data.stateName,
        data.block, //changes
        e.target.value, //changes
        data.deviceId //changes
      )
    );
  };

  useEffect(() => {
    console.log(status.userAndDevices?.successData?.data, "ALL THE DATA");

    console.log(
      [
        ...new Set(
          status.userAndDevices?.successData?.data.map((item) => item.device_id)
        ),
      ],
      "ALL THE items"
    );
  });

  // energy data

  const getDate1 = (e) => {
    const startDate = moment(e[0]);
    const endDate = moment(e[1]);

    const startDateNew = startDate.format("YYYY-MM-DD");
    const endDateNew = endDate.format("YYYY-MM-DD");
    setData({
      ...data,
      startDate: startDateNew,
      endDate: endDateNew,
    });
    dispatch(
      paiChartDevice(startDateNew, endDateNew, data.project, data.stateName)
    );
  };
  const clearDate1 = () => {
    setData({
      ...data,
      startDate: "",
      endDate: "",
    });
    dispatch(paiChartDevice("", "", data.project, data.stateName));
  };

  const getDate2 = (e) => {
    const startDate = moment(e[0]);
    const endDate = moment(e[1]);

    const startDateNew = startDate.format("YYYY-MM-DD");
    const endDateNew = endDate.format("YYYY-MM-DD");

    function getTop10Dates(start, end) {
      const dates = [];
      let currentDate = start.clone();

      while (currentDate <= end && dates.length < 7) {
        dates.push(currentDate.clone().format("ddd"));
        currentDate.add(1, "days");
      }

      return dates;
    }
    const top10Dates = getTop10Dates(startDate, endDate);
    setSelectedDates1(top10Dates);
    setData({
      ...data,
      AstartDate: startDateNew,
      AendDate: endDateNew,
    });
    dispatch(
      averageDeviceUsage(
        startDateNew,
        endDateNew,
        data.project,
        data.stateName,
        data.deviceId
      )
    );
  };
  const clearDate2 = () => {
    setData({
      ...data,
      AstartDate: "",
      AendDate: "",
    });
    dispatch(
      averageDeviceUsage("", "", data.project, data.stateName, data.deviceId)
    );
  };

  // dashboard data
  useEffect(() => {
    if (status.dashboardDeviceGraph?.data !== "") {
      if (status.dashboardDeviceGraph?.data.status === 200) {
        const transformedData = [
          {
            type: "bar",
            stack: "stack",
            id: "auto-generated-id-0",
            label: "Hours",
            data: status.dashboardDeviceGraph?.data?.data.map(
              (item) => item?.total_duration_hours
            ),
          },
        ];
        const monthNames = status.dashboardDeviceGraph?.data?.data.map(
          (item) => item?.month_name
        );
        setDeviceSeries(transformedData);
        setDeviceXAxisData(monthNames);
      }
    }
  }, [status]);
  useEffect(() => {
    if (status.dashboardUserGraph?.data !== "") {
      if (status.dashboardUserGraph?.data.status === 200) {
        const transformedData = [
          {
            type: "bar",
            stack: "stack",
            id: "auto-generated-id-0",
            label: "Users",
            data: status.dashboardUserGraph?.data?.data.map(
              (item) => item.user_count
            ),
          },
        ];
        const monthNames = status.dashboardUserGraph?.data?.data.map(
          (item) => item.month_name
        );
        setSeries(transformedData);
        setXAxisData(monthNames);
      }
    }
  }, [status]);

  useEffect(() => {
    if (status.energy?.data !== "") {
      if (status.energy?.data.status === 200) {
        setEnergyData(status.energy?.data.data);
      }
      if (status.energy?.data?.response != null) {
        if (status.energy?.data?.response?.status === 401) {
          toast.error(status.energy?.data?.response?.data?.error, {
            position: "bottom-right",
            theme: "colored",
          });
          window.sessionStorage.clear();
          let path = `/`;
          navigate(path);
        }
      }
    }
  }, [status]);

  useEffect(() => {
    if (status.paiChartDevice?.data === "") {
      if (status.paiChartDevice?.successData?.status === 200) {
        setPaichart(status.paiChartDevice?.successData?.data);
      }
    }
  }, [status]);
  useEffect(() => {
    if (status.averageDeviceUsage?.data === "") {
      if (status.averageDeviceUsage?.successData?.status === 200) {
        const transformedData = [
          {
            type: "bar",
            stack: "stack",
            id: "auto-generated-id-0",
            label: "Average",
            data:
              status.averageDeviceUsage?.successData?.data?.length > 0
                ? status.averageDeviceUsage?.successData?.data
                    ?.slice(-7)
                    .map((item) => item?.uptime)
                : data.AendDate && data.AstartDate
                ? [0, 0, 0, 0, 0, 0, 0]
                : [0, 0, 0, 0, 0, 0, 0],
          },
        ];
        const monthNames =
          status.averageDeviceUsage?.successData?.data?.length > 0
            ? status.averageDeviceUsage?.successData?.data
                ?.slice(-7)
                .map((item) => {
                  const date = item?.date;
                  return date ? moment(date).format("MMM DD") : null;
                })
            : data.AendDate && data.AstartDate
            ? selectedDates1
            : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        setSelectedDates(monthNames);
        setAverageDevice(transformedData);
      }
    }
  }, [status]);

  useEffect(() => {
    if (status.dashboard.data !== "") {
      if (status.dashboard.data && status.dashboard.data !== 200) {
        setDashboardData(status.dashboard.data);
      }
    }
  }, [status.dashboard.data]);

  const parmsDataSet = (data1, data2, data3) => {
    window.sessionStorage.setItem("eParmsName", data1);
    window.sessionStorage.setItem("eParmsDeviceId", data2);
    window.sessionStorage.setItem("eParmsDeviceRef", data3);
  };
  return (
    <>
      <div className="topSection">
        <div className="topSectionleft">
          <h3>
            Dashboard
            <span>
              <img alt="" src="../image/dashboard.svg"></img> / Dashboard
            </span>
          </h3>
        </div>
        <div className="topSectionright">
          <div className="mainbtn">
            <Link to="/dashboard/AddNewUser">Add New User</Link>
            <Link to="/dashboard/AddNewDevice">Add New Device</Link>
          </div>
        </div>
      </div>
      <div className="dashboardcontant">
        <div className="userFilter p-0">
          <div className="adduserwrap">
            <div className="selectfield">
              <div className="customfield">
                <span className="pageimage">
                  <img alt="img" src="../image/project.svg"></img>
                </span>
                <Box component="form" noValidate autoComplete="off">
                  <div>
                    <TextField
                      id="filled-select-currency"
                      select
                      label="Select Project Name"
                      variant="filled"
                      onChange={(e) => filterProject(e)}
                    >
                      <MenuItem value={""}>Select Project Name</MenuItem>
                      {projectLst?.map((option) => (
                        <MenuItem
                          key={option?.projectId}
                          value={option?.projectName}
                        >
                          {option?.projectName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Box>
                <img
                  alt="img"
                  src="../image/arrowb.svg"
                  className="arrowb"
                ></img>
              </div>
            </div>
            <div className="selectfield">
              <div className="customfield">
                <span className="pageimage">
                  <img alt="img" src="../image/location.svg"></img>
                </span>
                <Box component="form" noValidate autoComplete="off">
                  <div>
                    <TextField
                      id="filled-select-currency"
                      select
                      label="Select State"
                      variant="filled"
                      onChange={(e) => stateChange(e)}
                    >
                      <MenuItem value={""}>Select State</MenuItem>
                      {[
                        ...new Set(
                          status.userAndDevices?.successData?.data.map(
                            (item) => item.user_state
                          )
                        ),
                      ]?.map((option, i) => {
                        console.log(option, "From Select State");

                        return (
                          <MenuItem key={i} value={option}>
                            {option}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </div>
                </Box>
                <img
                  alt="img"
                  src="../image/arrowb.svg"
                  className="arrowb"
                ></img>
              </div>
            </div>

            {/* changes */}
            <div className="selectfield">
              <div className="customfield">
                <span className="pageimage">
                  <img alt="img" src="../image/location.svg"></img>
                </span>
                <Box component="form" noValidate autoComplete="off">
                  <div>
                    <TextField
                      id="filled-select-currency"
                      select
                      label="Select District"
                      variant="filled"
                      onChange={(e) => districtChange(e)}
                    >
                      <MenuItem value={""}>Select District</MenuItem>
                      {[
                        ...new Set(
                          status.userAndDevices?.successData?.data.map(
                            (item) => item.user_district
                          )
                        ),
                      ]?.map((option, i) => (
                        <MenuItem key={i} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Box>
                <img
                  alt="img"
                  src="../image/arrowb.svg"
                  className="arrowb"
                ></img>
              </div>
            </div>

            {/* changes */}
            <div className="selectfield">
              <div className="customfield">
                <span className="pageimage">
                  <img alt="img" src="../image/location.svg"></img>
                </span>
                <Box component="form" noValidate autoComplete="off">
                  <div>
                    <TextField
                      id="filled-select-currency"
                      select
                      label="Select Block"
                      variant="filled"
                      onChange={(e) => blockChange(e)}
                    >
                      <MenuItem value={""}>Select block</MenuItem>
                      {[
                        ...new Set(
                          status.userAndDevices?.successData?.data.map(
                            (item) => item.block
                          )
                        ),
                      ]?.map((option, i) => (
                        <MenuItem key={i} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Box>
                <img
                  alt="img"
                  src="../image/arrowb.svg"
                  className="arrowb"
                ></img>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboxwrap">
          <div className="dashbox">
            <div className="dashbox-left">
              <h3>
                {dashboarddata?.data?.totalUsers
                  ? dashboarddata?.data?.totalUsers
                  : "0"}
              </h3>

              <h4>Total Users</h4>
              {/* <p><img alt="" src="../image/arrow.svg"></img> 14% more than April</p> */}
            </div>

            <div className="dashbox-right">
              <img alt="" src="../image/users.svg"></img>
            </div>
          </div>
          <div className="dashbox">
            <div className="dashbox-left">
              <h3>
                {dashboarddata?.data?.totaldevice
                  ? dashboarddata?.data?.totaldevice
                  : "0"}
              </h3>
              <h4>Total Devices</h4>
              {/* <p><img alt="" src="../image/arrow.svg"></img> 14% more than April</p> */}
            </div>
            <div className="dashbox-right">
              <img alt="" src="../image/dish.svg"></img>
            </div>
          </div>
          <div className="dashbox">
            <div className="dashbox-left">
              <h3>
                {dashboarddata?.data?.totalassigneddevice
                  ? dashboarddata?.data?.totalassigneddevice
                  : "0"}
              </h3>
              <h4 className="assigned">Total Assigned</h4>
            </div>
            <div className="dashbox-right">
              <img alt="" src="../image/users.svg"></img>
            </div>
          </div>
          <div className="dashbox">
            <div className="dashbox-left">
              <h3>
                {dashboarddata?.data?.totalunassigneddevice
                  ? dashboarddata?.data?.totalunassigneddevice
                  : "0"}
              </h3>
              <h4 className="unassigned">Total Unassigned</h4>
            </div>
            <div className="dashbox-right">
              <img alt="" src="../image/users.svg"></img>
            </div>
          </div>
        </div>

        <div className="devicechartwrap">
          <div className="devicechart chart-box-bg">
            <h2>Devices Usage</h2>
            <p>Total Duration Usages monthly in 2024</p>
            <div className="chartcustom">
              <BarChart
                xAxis={[
                  {
                    scaleType: "band",
                    data: DevicexAxisData,
                  },
                ]}
                series={Deviceseries}
                width={550}
                height={400}
              />
            </div>
          </div>
          <div className="devicechart chart-box-bg">
            <h2>New Users</h2>
            <p>Total No. of Users added monthly in 2024</p>
            <div className="chartcustom">
              <BarChart
                xAxis={[
                  {
                    scaleType: "band",
                    data: xAxisData,
                  },
                ]}
                series={series}
                width={550}
                height={400}
              />
            </div>
          </div>
        </div>

        <div className="devicechartwrap pt-4 pb-4">
          <div className="devicechart">
            <h2>Device Usage By Hours</h2>
            <p>No. of Devices</p>
            <div className="userFilter pt-4 pl-0">
              <div className="adduserwrap">
                <div className="selectfield">
                  <div className="customfield datepick1">
                    <span className="pageimage">
                      <img alt="img" src="../image/calender1.svg"></img>
                    </span>
                    <DateRangePicker
                      placement="auto"
                      placeholder="Select Date"
                      onOk={(e) => getDate1(e)}
                      onClean={() => clearDate1()}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="chartcustom">
              <PieChart
                series={[
                  {
                    data: paichart,
                  },
                ]}
                width={530}
                height={200}
              />
            </div>
          </div>
          <div className="devicechart">
            <h2>Average Device Usage Per Day</h2>
            <p>Average Hours</p>
            <div className="userFilter pt-4 pl-0">
              <div className="adduserwrap gap-20">
                <div className="selectfield">
                  <div className="customfield datepick1">
                    <span className="pageimage">
                      <img alt="img" src="../image/calender1.svg"></img>
                    </span>
                    <DateRangePicker
                      placement="auto"
                      placeholder="Select Date"
                      onOk={(e) => getDate2(e)}
                      onClean={() => clearDate2()}
                      shouldDisableDate={combine(
                        allowedMaxDays(7),
                        afterToday()
                      )}
                    />
                  </div>
                </div>

                <div className="selectfield dash-user-f">
                  <div className="customfield">
                    <span className="pageimage">
                      <img alt="img" src="../image/users.svg"></img>
                    </span>
                    <Box component="form" noValidate autoComplete="off">
                      <div>
                        <TextField
                          id="filled-select-currency"
                          select
                          label="Select District"
                          variant="filled"
                          onChange={(e) => districtChangeFilter(e)}
                        >
                          <MenuItem value={""}>Select District</MenuItem>
                          {[
                            ...new Set(
                              status.userAndDevices?.successData?.data.map(
                                (item) => item?.user_district
                              )
                            ),
                          ]?.map((option, i) => {
                            console.log(option);

                            return (
                              <MenuItem key={i} value={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </div>
                    </Box>
                    <img
                      alt="img"
                      src="../image/arrowb.svg"
                      className="arrowb"
                    ></img>
                  </div>
                </div>

                {/* <div className="selectfield dash-user-f">
                  <div className="customfield">
                    <span className="pageimage">
                      <img alt="img" src="../image/users.svg"></img>
                    </span>
                    <Box component="form" noValidate autoComplete="off">
                      <div>
                        <TextField
                          id="filled-select-currency"
                          select
                          label="Select User"
                          variant="filled"
                          onChange={(e) => userChange(e)}
                        >
                          <MenuItem value={""}>Select User</MenuItem>
                          {userDevice?.map((option, i) => (
                            <MenuItem key={i} value={option?.device_id}>
                              {option?.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                    </Box>
                    <img
                      alt="img"
                      src="../image/arrowb.svg"
                      className="arrowb"
                    ></img>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="chartcustom chart-box-bg">
              <BarChart
                xAxis={[
                  {
                    scaleType: "band",
                    data: selectedDates,
                  },
                ]}
                series={averageDevice}
                width={550}
                height={400}
              />
            </div>
          </div>
        </div>
        <div className="devicechart tabalwrap">
          <div className="tablewrappadd">
            <h2>Cookstove Usage Summary</h2>
            <p>Recently Device Usages</p>
          </div>
          <div className="customtabel">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>User Name</TableCell>
                    {/* <TableCell>Project Name</TableCell> */}
                    <TableCell>District</TableCell>
                    <TableCell>Stove ID</TableCell>
                    <TableCell>Last Used</TableCell>
                    <TableCell>Total No. of Usages</TableCell>
                    <TableCell>Total Duration</TableCell>
                    <TableCell>Battery (%)</TableCell>
                    <TableCell>State</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {energydata?.slice(0, 10).map((energydata, i) => {
                    {
                      /* {energydata?.map((energydata, i) => { */
                    }
                    const originalDate = energydata?.start_date;
                    const trimDate = moment(originalDate)
                      .toISOString()
                      .slice(0, -1);
                    const formattedDate =
                      moment(trimDate).format("MMM DD, YYYY");
                    var originalDate1 = moment(energydata?.start_date);
                    const trimTime1 = moment(originalDate1)
                      .toISOString()
                      .slice(0, -1);
                    var formattedTime = moment(trimTime1).format("hh:mm A");
                    var originalDate2 = moment(energydata?.end_date);
                    const trimTime2 = moment(originalDate2)
                      .toISOString()
                      .slice(0, -1);
                    var formattedTime2 = moment(trimTime2).format("hh:mm A");

                    const totalSeconds = energydata?.total_duration_hours;
                    const duration = moment.duration(totalSeconds, "seconds");
                    const hours = Math.floor(duration.asHours());
                    const minutes = duration.minutes();
                    const seconds = duration.seconds();
                    return (
                      <TableRow
                        key={i}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <div className="tfirst">
                            <div className="tfleft tfleft2">
                              <span className="pageimage">
                                <img alt="" src="../image/profile.svg"></img>
                              </span>
                            </div>
                            <div className="tfright tfright2">
                              <p className="green">
                                <Link
                                  onClick={() =>
                                    parmsDataSet(
                                      energydata?.name,
                                      energydata?.device_id,
                                      energydata?.device_ref_num
                                    )
                                  }
                                  to={`/dashboard/EnergySummary/${energydata.user_id}`}
                                >
                                  {energydata.name}
                                </Link>
                              </p>
                              <span>{energydata.email}</span>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="tfright">
                            <p className="green">{energydata?.user_district}</p>
                          </div>
                        </TableCell>
                        {/* <TableCell>
                          <div className="tfright">
                            <p className="green">{energydata?.project_name}</p>
                          </div>
                        </TableCell> */}
                        <TableCell>
                          <div className="tfright">
                            <p className="green">{energydata.stove_id}</p>
                            {/* <p className="green">IOT {energydata.device_id}</p> */}
                            {/* <span>REF #{energydata.device_ref_num}</span> */}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="tfright">
                            <p>{formattedDate}</p>
                            <span>
                              {/* {formattedTime} - {formattedTime2} */}
                            </span>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="tfright">
                            <p className="green">
                              <Link
                                onClick={() =>
                                  parmsDataSet(
                                    energydata?.name,
                                    energydata?.device_id,
                                    energydata?.device_ref_num
                                  )
                                }
                                // to={`/dashboard/one-day-usages/${energydata?.device_id}/${energydata?.start_date}`}
                                to={`/dashboard/EnergySummary/${energydata.user_id}`}
                              >
                                {energydata?.no_of_usage}{" "}
                                {energydata?.no_of_usage > 1 ? "Times" : "Time"}
                              </Link>
                            </p>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="tfright">
                            <p>
                              {`${hours !== 0 ? hours + " hr," : ""} ${
                                minutes !== 0 ? minutes + " min," : ""
                              } ${seconds !== 0 ? seconds + " sec" : ""}`}
                            </p>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="tfright">
                            <p>{energydata?.battery}</p>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="tfright">
                            <p>{energydata?.user_state}</p>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {energydata === null ? (
              <div className="no-data-found">
                <img alt="img" src="../image/noDataFound.svg"></img>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default Dashboard;
